import React, { Component } from "react";
import { Menu, Button, Dropdown } from "antd";

import WeaNewScroll from "../wea-new-scroll";
import WeaDropdown from "../wea-dropdown";
import WeaLocaleProvider from "../wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

const { ButtonSelect } = WeaDropdown;

export default class ActionButtons extends Component {
  static displayName = "ActionButtons";

  getMoveDropPropsDatas() {
    const { moveDropDatas, prefixCls } = this.props;
    const { datas, addBtn, onMenuClick } = moveDropDatas;
    if (Array.isArray(datas) && datas.length > 0) {
      return {
        move: {
          overlay: (
            <div
              className={`${prefixCls}-dropmenu-warp`}
              style={{
                paddingBottom: addBtn ? 32 : 0,
                maxHeight: Array.isArray(addBtn)
                  ? 194 + addBtn.length * 42
                  : 230
              }}
            >
              <WeaNewScroll height={(datas.length > 6 ? 6 : datas) * 32}>
                <Menu
                  prefixCls={`${prefixCls}-dropmenu ant-dropdown-menu`}
                  onClick={e => {
                    typeof onMenuClick === "function" && onMenuClick(e.key, e);
                  }}
                >
                  {datas.map(d => (
                    <Menu.Item key={d.key} disabled={d.disabled}>
                      {d.show}
                    </Menu.Item>
                  ))}
                </Menu>
              </WeaNewScroll>
              <Menu
                prefixCls={`${prefixCls}-dropmenu ant-dropdown-menu`}
                onClick={
                  Array.isArray(addBtn)
                    ? e => {
                        addBtn.forEach(item => {
                          typeof item.onClick === "function" &&
                            item.key === e.key &&
                            item.onClick(e.key, e);
                        });
                      }
                    : e => {
                        typeof addBtn.onClick === "function" &&
                          addBtn.onClick(e);
                      }
                }
              >
                {addBtn ? (
                  Array.isArray(addBtn) ? (
                    addBtn.map(item => (
                      <Menu.Item
                        className={`${prefixCls}-dropmenu-addbtn`}
                        {...item}
                        key={item.key}
                        disabled={item.disabled}
                      >
                        {item.show}
                      </Menu.Item>
                    ))
                  ) : (
                    <div
                      className={`${prefixCls}-dropmenu-addbtn-single`}
                      {...addBtn}
                    >
                      {addBtn.show}
                    </div>
                  )
                ) : null}
              </Menu>
            </div>
          )
        }
      };
    }
    return {};
  }

  getAddBtn() {
    const {
      showAdd,
      viewAttr,
      addButtonType,
      addDropDatas,
      onBtnClick
    } = this.props;
    if (!showAdd) return null;
    const disabled = viewAttr === 1;
    const props = {
      type: "primary",
      disabled,
      size: "small",
      title: getLabel("611", "添加")
    };
    const { datas, onMenuClick } = addDropDatas;
    if (addButtonType === "drop" && Array.isArray(datas) && datas.length > 0) {
      return (
        <Dropdown
          overlay={
            <Menu
              onClick={e => {
                typeof onMenuClick === "function" && onMenuClick(e.key, e);
              }}
            >
              {datas.map(d => (
                <Menu.Item key={d.key} disabled={d.disabled}>
                  {d.show}
                </Menu.Item>
              ))}
            </Menu>
          }
        >
          <Button {...props}>
            <i className="icon-coms-Add-to-hot" />
          </Button>
        </Dropdown>
      );
    }
    return (
      <Button {...props} onClick={() => onBtnClick("add")}>
        <i className="icon-coms-Add-to-hot" />
      </Button>
    );
  }

  getBtnsArray() {
    const { viewAttr, showDelete, showCopy, showMove, customBtns } = this.props;
    const readOnly = viewAttr === 1;
    let btns = [];
    if (!readOnly) {
      showDelete &&
        btns.push({
          key: "delete",
          text: getLabel("91", "删除"),
          show: <i className="icon-coms-form-delete-hot" />
        });
      showCopy &&
        btns.push({
          key: "copy",
          text: getLabel("77", "复制"),
          show: <i className="icon-coms-copy-hot" />
        });
      showMove &&
        btns.push({
          key: "move",
          text: getLabel("81296", "移动到组"),
          show: <i className="icon-coms-move2" />,
          isDropBtn: true
        });
      if (customBtns) {
        btns = [...btns, ...customBtns];
      }
    }
    return btns;
  }

  getCollapseBtn() {
    const { showCollapse, collapsed, onCollapse } = this.props;
    return showCollapse ? (
      <i
        style={{
          marginLeft: 10,
          color: "#b2b2b2",
          cursor: "pointer",
          lineHeight: "20px"
        }}
        className={`icon-coms-${collapsed ? "down" : "up"}`}
        onClick={() => onCollapse(!collapsed)}
      />
    ) : null;
  }

  getBtnsInline() {
    const { viewAttr, onBtnClick, selectedRowKeys } = this.props;
    const readOnly = viewAttr === 1;
    const btns = this.getBtnsArray();
    const btnDropPropsDatas = this.getMoveDropPropsDatas();
    return btns.map(btn => {
      const _btn = (
        <Button
          type="primary"
          disabled={readOnly || !`${selectedRowKeys}`}
          title={btn.text}
          size="small"
          onClick={() => onBtnClick(btn.key)}
        >
          {btn.show}
        </Button>
      );
      const btnDropProps = btnDropPropsDatas[btn.key] || { overlay: <span /> };
      return btn.isDropBtn ? (
        <Dropdown trigger={["click"]} {...btnDropProps}>
          {_btn}
        </Dropdown>
      ) : (
        _btn
      );
    });
  }

  getBtnsSelect() {
    const btns = this.getBtnsArray();
    if (btns.length === 0) return null;
    const {
      selectedBtnKey,
      viewAttr,
      selectedRowKeys,
      onBtnsSelect,
      onBtnClick
    } = this.props;
    const readOnly = viewAttr === 1;
    const selectedKey = selectedBtnKey || btns[0].key;
    const selected = btns.filter(b => b.key === selectedKey);
    const btn = selected[0];
    const btnDropPropsDatas = this.getMoveDropPropsDatas();
    if (btns.length === 1) {
      return (
        <Button
          type="primary"
          disabled={readOnly || !`${selectedRowKeys}`}
          title={btn.text}
          size="small"
          onClick={() => onBtnClick(btn.key)}
        >
          {btn.show}
        </Button>
      );
    }
    return (
      <ButtonSelect
        type="small"
        selectedKey={selectedKey}
        btnProps={{
          title: btn.text || "",
          disabled: readOnly || !`${selectedRowKeys}`,
          size: "small"
        }}
        datas={btns}
        btnDropPropsDatas={btnDropPropsDatas}
        btnOnClick={key => onBtnClick(key)}
        menuOnClick={key => onBtnsSelect(key)}
      />
    );
  }

  render() {
    const { prefixCls, buttonsType, columns } = this.props;
    if (columns.length === 0) return null;
    return (
      <span className={`${prefixCls}-btns`}>
        {this.getAddBtn()}
        {buttonsType === "inline" ? this.getBtnsInline() : this.getBtnsSelect()}
        {this.getCollapseBtn()}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-table-editable/ActionButtons.js